import Vue from 'vue';
import debounce from "lodash.debounce";

/*  -----------------------------------------------------------
output: this.$emit('searchComplete', { searchResults: [], typeValue: string, typeName: string, })
    ----------------------------------------------------------- */
export default {
  name: 'SearchBarWithSearchOptionss',
  props: {
    searchDefaultType: {
      type: Number,
      default: null
    },
    searchTypeList: {
      /* f.e. 
      [{ name: 'Billing', id: 1}, { name: 'BookWalks', id: 2},
      {
          name: this.$t('captureMR.StatementNo'), id: 1, field: 'StatementNo', boolean: true,
          choices: [
            { name: 'Has Statement', id: 1, value: true }, ================> 1 for true
            { name: 'Does Not Have Statement', id: 2, value: false},================> 0 for false
          ]
        },]

      */
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchFunction: {
      type: Function,
      required: true
    },
    displayLoader: {
      type: Boolean,
      default: true
    },
    debounceSearchTime: { //debounce time, less than 0 no debounce
      type: Number,
      default: 2000
    }
  },
  data: function () {
    return {
      searchQuery: '',
      searchTypeOption: null,
      debounceInProgress: false,
      booleanChoices: [],
      booleanSearchQuery: null,
    }
  },
  computed: {
    getCursorNotAllowedClass: function () {
      if (this.disabled)
        return 'cursor-not-allowed'
      else
        return '';
    },
    showInput: function () {
      let item = this.searchTypeList.filter(s => s.id === this.searchTypeOption)[0];

      if (item.boolean === true) {
        this.booleanChoices = [...item.choices];       
        this.booleanSearchQuery = this.booleanChoices[0].value;
        return false;
      }
      else {
        this.booleanChoices.length = 0;
        this.booleanSearchQuery = null;
        return true;
      }
    },
    searchDisabled: function () {
      return this.disabled || ((this.searchQuery == null || this.searchQuery == '') && this.showInput) || (this.booleanSearchQuery == null && !this.showInput);
    }
  },
  watch: {
    searchDefaultType: function (val) {
      if (val)
        this.searchTypeOption = val;
    },
    searchQuery: function (val) {
      if (val != '' && val != null) {
        if (this.debounceSearchTime > 0)
          this.debouncedFunc();
        else
          this.searchFunc();
        this.debounceInProgress = true;
      }
      else
        this.searchFunc(true);
    },
    booleanSearchQuery: function (val) {
      this.searchFunc();
    }
  },
  created() {
    this.debouncedFunc = debounce(() => {
      this.searchFunc();
    }, this.debounceSearchTime);

    if (this.searchDefaultType != null)
      this.searchTypeOption = this.searchDefaultType;
    else {
      if (this.searchTypeList.length > 0)
        this.searchTypeOption = this.searchTypeList[0].id;
    }
  },
  beforeUnmount() {
    this.debounceFunc.cancel();
  },
  methods: {
    searchFunc(cleared = false) {
      let resp = {};

      if (this.searchTypeList.length > 0) {
        let item = this.searchTypeList.filter(s => s.id == this.searchTypeOption)[0];
        let query = this.searchQuery;
        let boolChoice = this.booleanSearchQuery;

        resp['field'] = item.field;
        resp['query'] = item.boolean ? boolChoice : query;
        resp['clear'] = cleared;

        if (resp['query'] == null) {
          delete resp['query'];
          delete resp['filed'];
          resp['clearSearch'] = true;
        }
        else
          resp['clearSearch'] = false;
      }

      
        this.searchFunction(resp);

      this.debounceInProgress = false;
    },
    searchTypeOptionSelected() {
      if (this.searchQuery != null &&this.searchQuery.length > 0)
        this.searchFunc();
    },
    clearBoolSelection() {
      this.booleanSearchQuery = null;
    }
  }
}
